import React, { Component } from "react";
import { connect } from "react-redux";
import { getFinancicalSchemas } from "../../../store/actions";
import { withRouter } from "react-router";

import Tables from "./Table";
// import Ecxell from "./Excell";

class FinancicalStructure extends Component {
  async componentDidMount() {
    await this.props.getFinancicalSchemas();
  }

  render() {
    const Schemas = this.props.schemas.financicalSchemas
      .user_financial_structures;
    return (
      <React.Fragment>
        <Tables schemas={Schemas} />
        {/* <Ecxell /> */}
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return { schemas: state };
}

export default withRouter(
  connect(
    mapStateToProps,
    { getFinancicalSchemas }
  )(FinancicalStructure)
);



// WEBPACK FOOTER //
// ./src/views/Seasonability/Seasonability/FinancicalStructure.js